// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-submissions .filters,.form-submissions .filter-bar__wrapper{display:flex}.form-submissions .filters .ui-filter,.form-submissions .filter-bar__wrapper .ui-filter{margin-right:5px}.form-submissions .dropdown-menu .ui-button{height:36px}", ""]);
// Exports
module.exports = exports;
